import { render, staticRenderFns } from "./UpgradeDetails.vue?vue&type=template&id=98a6dd62&scoped=true&"
import script from "./UpgradeDetails.vue?vue&type=script&lang=js&"
export * from "./UpgradeDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeDetails.vue?vue&type=style&index=0&id=98a6dd62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a6dd62",
  null
  
)

export default component.exports